export default __webpack_public_path__ + "static/media/category_31.81a1707d.png";